export const handleResponse = response => {
  console.log('server api response : ', response);

  // 성공인 경우에 컨텐츠만 반환한다.
  // 성공이라고 하더라도 컨텐츠가 없이 결과만 성공으로 반환하는 경우가 있다.
  // 이런 때에는 Empty Object를 반환한다.
  // -> counterpencil:  다음 로직에서 처리하는 것으로 수정
  return response ? response : {};
};

export const handleException = error => {
  // error handling
  // console.log("error", error);
  return Promise.reject(error);
};

export const handleData = response => {
  const data = response?.data;

  // HTTP 200이지만 응답 본문에 에러가 있는 경우 (예: { error: true, desc: '...' })
  if (data && data.error != null && data.error !== false && data.error !== '') {
    const message = data.desc || data.message || '알 수 없는 오류가 발생했습니다.';
    return Promise.reject(new Error(message));
  }

  return data;
};
